import { ROUND_ID_KEY } from '@portal/common/models/data-key';
import { DataProjectId } from '@portal/common/models/data-project';
import { DataKey, DataType } from '@portal/common/types';
import { localizeColumn } from '@portal/common/utility/chart-data-helpers';

import _ from '../locale';

export const getRoundLabelOverride = (
    key: string,
    selectedDataProject: number | undefined
): string | null =>
    key === ROUND_ID_KEY && selectedDataProject === DataProjectId.RACE_ETHNICITY
        ? _('refinement_round_id_re_reporting_version')
        : null;

export const localizeDataColumn = (
    column: DataKey,
    dataTypes: DataType[],
    selectedDataProject: number | undefined,
    replaceSpaces = false
): string => {
    const label =
        getRoundLabelOverride(column, selectedDataProject) ?? localizeColumn(column, dataTypes, _);

    return replaceSpaces ? label.replace(/\s+/g, '_') : label;
};
